import React from "react";
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Autocomplete} from "@material-ui/lab";
import { clientesResources , controlRespaldoResources, inventarioResources } from "../endpoints";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import es from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";

class DialogPlanificarRespaldo extends React.Component{
    constructor(props) {
        super(props);
            this.state = {
                iniciar: true,
                clientes:[],
                cliente:null,
                tiendas:[],
                tienda:null,
                selectedDate: null,
                nombre:'',
                inv_programados:[],
                folio:null,
            };
    };

    handleDateChange = (date) => {
        this.setState({ selectedDate: date }, () => {
            // Solo busca en la API si realmente hay una fecha válida seleccionada
            if (date && !isNaN(date.getTime())) { 
                this.obtenerInvProgramados();
            } else {
                // Si la fecha se limpia, reseteamos los inventarios programados
                this.setState({ inv_programados: [], folio: null });
            }
        });
    };

    handleClick = () =>{
        var d = new Date(this.state.selectedDate),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
    
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
    
        const datos={
                folio: this.state.folio,
                id_cliente:this.state.cliente.id,
                id_tienda: this.state.tienda.id,
                fecha_jornada: [year, month, day].join('-')
            }
        controlRespaldoResources.agregarControlRespaldo(datos).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }

    obtenerTiendasCliente = () =>{
        if(this.state.cliente !== ''){
            clientesResources.getTiendasCliente(this.state.cliente.id).then(async response => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).then(data => {
                this.setState({tiendas:data})
            }).catch(error=> {
                console.error(error);
            });
        }
    }

    obtenerClientes = () =>{
        clientesResources.getClientes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(data => {
            this.setState({clientes:data})
        }).catch(error=> {
            console.error(error);
        });
    }
    
    componentDidMount = () => {
        this.obtenerClientes();
    }

    obtenerInvProgramados =() =>{
            var d = new Date(this.state.selectedDate),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
    
            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;
    
            const fecha = [year, month, day].join('-'); 
    
            this.setState({openSnack:false, severity: null, message:null})
            inventarioResources.getInvProgramadosDia(this.state.tienda.id, fecha).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.status_code === 200){
                    this.setState({inv_programados:data.inv_programados})
                }
                else if (data.status_code === 401){
                    this.setState({openSnack:true, severity:data.severity, message:data.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
            });
    }

    render() {
        return(
            <Dialog
                open={this.state.iniciar}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12} style={{padding: '10px'}}>
                            <Autocomplete
                                id="size-small-standard"
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({cliente: null, tienda: null, folio: null, selectedDate:null, inv_programados:[]})
                                    }
                                    else{
                                        this.setState({cliente: newValue, tienda: null, folio: null, selectedDate:null, inv_programados:[]}, this.obtenerTiendasCliente)

                                    }
                                }}
                                size="small"
                                value={this.state.cliente}
                                options={this.state.clientes}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.descripcion || ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Clientes" placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} style={{padding: '10px'}}>
                            <Autocomplete
                                id="size-small-standard"
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({tienda: null, folio: null,selectedDate:null, inv_programados:[]})
                                    }
                                    else{
                                         this.setState({tienda: newValue, folio: null, selectedDate:null, inv_programados:[]})
                                    }
                                }}
                                size="small"
                                value={this.state.tienda}
                                options={this.state.tiendas}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.descripcion + " - " + option.centro || ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Tienda" placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} style={{padding: '10px'}}>
                            <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                                <Grid container>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="date-picker-inline"
                                        label="Fecha"
                                        placeholder="dd/mm/yyyy"
                                        value={this.state.selectedDate}
                                        onChange={this.handleDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </Grid>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} style={{padding: '10px'}}>
                            <Autocomplete
                                id="size-small-standard"
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({folio: null})
                                    }
                                    else{
                                            this.setState({folio: newValue})
                                    }
                                }}
                                size="small"
                                value={this.state.folio}
                                options={this.state.inv_programados}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option ? option.toString() : ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Folio" placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.folio || !this.state.selectedDate || !this.state.tienda || !this.state.cliente} variant="contained"  color="primary" onClick={this.handleClick}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogPlanificarRespaldo;